import { CustomComponent, IBakeryCountry } from '@cakeiteasy/web-utils';
import { CART_DELIVERY_TYPES, DeliveryApiService } from '@cakeiteasy/order-process';
import { ModalOpenerService } from '@modals/modal-opener.service';
import { ComponentFactoryResolver, Directive } from '@angular/core';

@Directive({ standalone: false })
export class DeliveryCheckerBaseComponent extends CustomComponent {
  constructor(protected _deliveryApi: DeliveryApiService,
              protected _modalOpener: ModalOpenerService,
              protected _componentResolver: ComponentFactoryResolver) {
    super();
  }

  public showDeliveryChecker(event: {
    deliveryType: CART_DELIVERY_TYPES,
    bakeryId: number,
    country: IBakeryCountry,
    productTypeId?: number,
  }): Promise<any> {
    const { PICKUP, DELIVERY } = CART_DELIVERY_TYPES;
    const { deliveryType, bakeryId, country, productTypeId } = event;

    const callers = {
      [PICKUP]: () => this.showOutletsMap(bakeryId, productTypeId),
      [DELIVERY]: () => this.showCheckDelivery({ bakeryId, country })
    };

    return callers[deliveryType]();
  }

  public async showOutletsMap(bakeryId: number, productTypeId: number): Promise<any> {
    try {
      const outlets = await this._deliveryApi.getOutletsByBakeryId(bakeryId, { productTypeIds: productTypeId });
      await this._modalOpener
        .showOutletsMap(this._componentResolver, outlets, [], {
          isShowAll: true, showHeader: false
        });
    } catch (e) {
    }
  }

  public showCheckDelivery(params: { country: IBakeryCountry, bakeryId: number }): Promise<any> {
    return this._modalOpener.showDeliveryPriceCheck(this._componentResolver, params)
      .catch(() => {
      });
  }
}
